// Dependencies
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const ModalDraggable = (props) => {

  const [modalClasses, setModalClasses] = useState("c-modal");

  useEffect(()=>{
    handleClasses()
    return () => {
      document.body.style.overflow = 'visible'
    }
  }, [props.isVisible])

  const handleClose = (e) => {
    console.log(e.target.classList)

    const modalClasses = e.target.classList
    if (modalClasses.contains("is-visible")) {
      props.closeModal && props.closeModal()
    } 
  }

  const handleClasses = () => {

    // Modal
    setModalClasses(
      classNames(
        "c-modal", 
        props.isVisible && "is-visible",
        props.small && "c-modal--small",
        props.medium && "c-modal--medium",
        props.className && props.className
      )
    )

    //Body
    if (props.isVisible) {
      let body = document.body
      if (getComputedStyle(body).overflow !== 'hidden') {
        body.style.overflow = 'hidden'
      }
    }
  }

  return (
    <div className={modalClasses} style={props.style || {}}onClick={handleClose}>
      <div className="" style={{marginInline: 'auto'}}>
        <div className="" style={{ margin: 'auto', backgroundColor: 'white', width: '70%',
          padding: 24, borderRadius: 20}}>{props.children}</div>
      </div>
    </div>
  );

}

ModalDraggable.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  small: PropTypes.bool,
};

export default ModalDraggable;
